import moment from 'moment';

const validDate = string => moment(string, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid();

export default validDate;
